import { Cluster, MarkerUtils } from '@googlemaps/markerclusterer';

export class GroupAwareCluster extends Cluster {
  /**
   * Get the number of visible markers in the cluster.
   * For group clusters, each partner in the group is counted towards the total.
   */
  public get count(): number {
    if (!this.markers) return 0;

    return this.markers
      .filter((m) => MarkerUtils.getVisible(m))
      .reduce((count, marker) => {
        if (!(marker instanceof google.maps.marker.AdvancedMarkerElement)) {
          return count + 1;
        }
        // Group markers will have a `text` element with the number of partners in the group
        const markerCount = Number(
          marker.element.querySelector('text')?.innerHTML ?? 1,
        );
        return count + markerCount;
      }, 0);
  }
}
